import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import type { FC } from 'react';

interface BreadcrumbsProps {
  isRegistrationMode: boolean;
  isAuthorizationMode: boolean;
}

const getSecondTitle = (
  isRegistrationMode: boolean,
  isAuthorizationMode: boolean
): string => {
  if (isRegistrationMode) return 'Регистрация';
  if (isAuthorizationMode) return 'Вход';
  return 'Application List';
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  isRegistrationMode,
  isAuthorizationMode,
}) => (
  <Breadcrumb
    items={[
      { title: <Link to="https://byhelp.ru/">Главная</Link> },
      { title: getSecondTitle(isRegistrationMode, isAuthorizationMode) },
    ]}
  />
);
